import { numberRoundDownWithDecimals } from '@betterment/shared-components';

import { PurposeProjectionQuery } from '../../graphql/purposeProjection.generated';

type Props = {
  purpose: Extract<PurposeProjectionQuery['purpose'], { __typename: 'PurposeEmergencyFund' }>;
};

export const EmergencyFundHeader = ({ purpose }: Props) => {
  const monthsCovered = numberRoundDownWithDecimals(purpose.monthsExpensesCovered, 1);

  return `Your current balance can cover ${monthsCovered} months of expenses.`;
};
